import { FrameBackground, FrameDetailsRendererProps } from './FrameDetailsRenderer.types';

const FrameDetailsRenderer = ({
  theme = FrameBackground.LIGHT,
  data,
}: FrameDetailsRendererProps): React.ReactElement => {
  const { visualUnitIds } = data ?? {};

  return (
    <button
      type="button"
      data-test-id="preview-frames"
      onClick={() => null}
      className={`p-2.5 text-center rounded-md ${theme}`}
    >
      <span>{visualUnitIds?.length}</span>
    </button>
  );
};

export default FrameDetailsRenderer;
